document.addEventListener('click', event => {
  const arrow = event.target.closest('.carousel-arrow--left, .carousel-arrow--right');
  if (!arrow) return;

  const wrapper  = arrow.closest('.upsell-carousel-wrapper');
  if(!wrapper) return;
  const carousel = wrapper.querySelector('.upsell-carousel-items');
  const items    = carousel.querySelectorAll('.upsell-item');

  if (!carousel || items.length === 0) return;

  const itemWidth    = items[0].offsetWidth;
  const maxIndex     = items.length - 1;
  const rawIndex     = carousel.scrollLeft / itemWidth;
  const currentIndex = Math.round(rawIndex);

  let newIndex = currentIndex;
  if (arrow.classList.contains('carousel-arrow--left')) {
    newIndex = Math.max(0, currentIndex - 1);
  } else {
    newIndex = Math.min(maxIndex, currentIndex + 1);
  }

  carousel.scrollTo({ 
    left: newIndex * itemWidth, 
    behavior: 'smooth' 
  });

  wrapper.querySelector('.carousel-arrow--left').disabled  = newIndex === 0;
  wrapper.querySelector('.carousel-arrow--right').disabled = newIndex === maxIndex;
});
